import { Head } from "@shopify/hydrogen";

export default function SetupAnalytics() {
    return (
    <> 
    {/* All page  */}
    </>)
}